// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"6a0323de","290":"65edcb13","305":"e90b6b35","372":"47f558a6","453":"4d5191a3","786":"358a709c","902":"347d7cbb"}[chunkId] + ".chunk.js";
};